import React, { createContext, useContext, useState } from 'react';
import axios from '../utils/api';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  
  // Auth functions
  const login = async (email, password) => {
    setIsLoading(true);
    try {
      const response = await axios.post('/api/users/login', { email, password });
      const userData = response.data;
      
      // Check if the user is an admin
      if (userData.role !== 'admin') {
        setIsLoading(false);
        throw new Error('Unauthorized: Only admin users can access this panel');
      }
      
      const adminUser = {
        id: userData._id,
        name: userData.name,
        email: userData.email,
        role: userData.role
      };
      
      // Store token in localStorage
      localStorage.setItem('token', userData.token);
      
      // Store admin user info
      setAdmin(adminUser);
      localStorage.setItem('adminUser', JSON.stringify(adminUser));
      
      setIsLoading(false);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      setIsLoading(false);
      return false;
    }
  };
  
  const logout = () => {
    setAdmin(null);
    localStorage.removeItem('adminUser');
    localStorage.removeItem('token');
  };
  
  // Check for stored admin session on initial load
  React.useEffect(() => {
    const storedAdmin = localStorage.getItem('adminUser');
    const token = localStorage.getItem('token');
    
    if (storedAdmin && token) {
      setAdmin(JSON.parse(storedAdmin));
    }
    setAuthChecked(true);
  }, []);

  // Data fetching functions remain the same
  const fetchDoctors = async () => {
    setIsLoading(true);
    try {
      // This would be an actual API call
      // For now, using mock data
      // ...
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching doctors:', error);
      setIsLoading(false);
    }
  };
  
  const fetchPatients = async () => {
    // Similar to fetchDoctors
  };
  
  const fetchAppointments = async () => {
    // Similar to fetchDoctors
  };

  return (
    <AdminContext.Provider value={{
      admin,
      isLoading,
      authChecked,
      login,
      logout,
      doctors,
      patients,
      appointments,
      fetchDoctors,
      fetchPatients,
      fetchAppointments
    }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminContext = () => useContext(AdminContext);
